import axios from 'axios';

export default {
  getUsersLogs({ commit, state }, { ctx, filter }) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/userlogs/get`,
        params: { ...ctx, ...filter },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertUsersLogs', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};
